import React from 'react';
// import { useSelector } from 'react-redux';
import { Routes, Route } from 'react-router-dom';
// import { layoutTypes } from './constants/layout';
// Import Routes all
import { publicRoutes } from './routes';

import NonAuthLayout from './components/NonAuthLayout';

// Import scss
import './assets/scss/theme.scss';

const App = () => {
  /* const { layoutType } = useSelector(state => ({
    layoutType: state.Layout.layoutType
  })); */

  return (
    <>
      <Routes>
        {publicRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={<NonAuthLayout>{route.component}</NonAuthLayout>}
            key={idx}
            exact
          />
        ))}
      </Routes>
    </>
  );
};

export default App;
